// ---------- CONSTANTS ----------
export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const HOURS = Array.from({ length: 12 }, (_, i) =>
  String(i + 1).padStart(2, "0")
);

export const MINUTES = ["00", "15", "30", "45"];
export const PERIODS = ["AM", "PM"];

export const defaultSlot = {
  open: "10:00 AM",
  close: "06:00 PM",
  patients: "",
};

// ---------- HELPERS ----------

// Build an empty schedule with default slot for each day
export const createEmptySchedule = () => {
  const result = {};
  DAYS.forEach((day) => {
    result[day] = {
      isClosed: false,
      slots: [{ ...defaultSlot }],
    };
  });
  return result;
};

// Convert "10:00 AM" → { hour, minute, period }
export const parseTime = (value = "10:00 AM") => {
  const [time, per = "AM"] = value.split(" ");
  const [h = "10", m = "00"] = (time || "").split(":");
  return {
    hour: h.padStart(2, "0"),
    minute: m.padStart(2, "0"),
    period: (per || "AM").toUpperCase(),
  };
};

// Convert hour + minute + period → "10:00 AM"
export const buildTime = (hour, minute, period) =>
  `${hour}:${minute} ${period}`;

 export const normalizeHospitalSchedule = (raw) => {
  if (!raw) return {};

  let obj = raw;

  // case 1: it's an array (like your example)
  if (Array.isArray(obj) && obj.length > 0) {
    obj = obj[0]; // take first element (you stored everything inside [ { ... } ])
  }

  // case 2: there is a "0" key containing another object with hospitalId
  if (obj["0"] && typeof obj["0"] === "object") {
    obj = { ...obj, ...obj["0"] };
    delete obj["0"];
  }

  const result = {};

  Object.entries(obj).forEach(([hospitalId, daysObj]) => {
    if (!daysObj || typeof daysObj !== "object") return;

    const normalizedDays = {};

    Object.entries(daysObj).forEach(([dayName, dayData]) => {
      if (!dayData || typeof dayData !== "object") return;

      const isClosedRaw = dayData.isClosed;
      const isClosed =
        isClosedRaw === true ||
        isClosedRaw === "true" ||
        isClosedRaw === 1 ||
        isClosedRaw === "1";

      const slots = Array.isArray(dayData.slots) ? dayData.slots : [defaultSlot];

      normalizedDays[dayName] = {
        isClosed,
        slots: slots.map((s) => ({
          open: s.open || "10:00 AM",
          close: s.close || "06:00 PM",
          patients: s.patients || "",
        })),
      };
    });

    result[hospitalId] = normalizedDays;
  });

  return result;
};